<template>
    <div style="display: flex; flex-direction: column;">
        <main-swiper></main-swiper>
        <div class="body">
            <div class="sort ">
                <div class="sort-item">
                    <div class="sort-item-title flex-center"><span>类型</span></div>
                    <div class="sort-item-content">
                        <ul>
                            <li :class="{'act':actList[2] == -100,'flex-center':true,'cursorPointer':true}" @click="handleChange(2,-100)">
                                <span>全部</span>
                            </li>
                            <li v-for="item in categoryList" :key="item.id" :class="{'act':actList[2] == item.id,'flex-center':true,'cursorPointer':true}" @click="handleChange(2,item.id)">
                                <span>{{item.categoryName}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sort-item cursorPointer" v-for="i in regularList" :key="i.title+i.mtype">
                    <div class="sort-item-title flex-center"><span>{{i.title}}</span></div>
                    <div class="sort-item-content">
                        <ul>
                            <li v-for="(item,index) in i.data" :key="index" :class="{'act':actList[i.mtype] == item.type,'flex-center':true,'cursorPointer':true}" @click="handleChange(i.mtype,item.type)">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="result">
                <comic-list_1 :dataList="resultList.records"></comic-list_1>
            </div>
            <Pagination
                @change="changePage"
                :current="pagination.pageNum"
                :pageSize="pagination.pageSize"
                :total="total"
                :hideOnSinglePage="hideOnSinglePage"
                :showQuickJumper="true"
                :showTotal="true"
                placement="right"
                v-if="pagination && total"
            />
        </div>
    </div>
</template>

<script setup>
    import Pagination from '@/components/pagination'
    import MainSwiper from '../components/mainSwiper.vue'
    import ComicList_1 from '../components/comicList_1.vue'
    import { categoryGetList, homeComicCategory } from '@/utils/api'
    import { onMounted, ref } from 'vue';
    import { useRoute } from "vue-router";
    let route = useRoute()
    let categoryList=ref([])
    let resultList=ref([])
    let actList=ref([-1,-1,-100])//第一个 进度 二 排序 三 类型
    let regularList=ref([
        {
            title:'进度',
            mtype:0,
            data:[{name:'全部',type:-1},{name:'连载中',type:0},{name:'已完结',type:1}]
        },
        {
            title:'排序',
            mtype:1,
            data:[{name:'推荐',type:-1},{name:'最新',type:1}]
        }
    ])
    let hideOnSinglePage=ref(false)
    let total=ref(0)
    let pagination=ref({
        pageSize: 20,
        pageNum: 1
    })
    onMounted(()=>{
        actList.value[2] = route.query.id ? route.query.id : -100
        setTimeout(()=>{
            getList()
            getResList()
        })
    })
    const changePage = (pager)=> { // 分页器回调
        // this.$emit('change', pager)
        getResList(pager.page)
        
    }
    const getResList=(val)=>{
        let  query= {
            pageNum: val ? val : pagination.value.pageNum,
            pageSize: pagination.value.pageSize,
            comicStatus: actList.value[0] == -1 ? '': actList.value[0],
            sort: actList.value[1] == -1 ? '': actList.value[1],
            categoryId: actList.value[2] == -100 ? '': actList.value[2],
        }
        resultList.value = []
        categoryGetList(query).then(res=>{
            resultList.value = res.data
            total.value = res.data.total
            pagination.value = res.data.current
        })
    }
    const getList=()=>{
        homeComicCategory().then(res=>{
            categoryList.value = res.data
        })
    }
    const handleChange=(type,id)=>{
        actList.value[type] = id
        getResList()
    }
    
</script>

<style lang="scss" scoped>
.body{
    min-width: 1188px;
    margin: 0 auto;
    padding: 40px 0 80px;
}
    .sort{
        &-item{
            margin-bottom: 35px;
            span{
                font-size: 14px;
                color: #666666;
                line-height: 20px;
                letter-spacing: 1px;
            }
            display: flex;
            &-title{
                margin-right: 30px;
            }
            ul{
                display: flex;
                li{
                    margin-right: 35px;
                    color: #333;
                    display: flex;
                    align-items: center;
                    img{
                        width: 10px;
                        height: 10px;
                        margin-left: 7px;
                    }
                }
                .act{
                    padding: 5px 13px;
                    background: #CB2945;
                    border-radius: 17px;
                    span{
                        color: #fff;
                    }
                }
            }
        }
    }
</style>